import { useCustom } from './useCustom';

export const useLoadingScreen = () => {
  const [state, setState] = useCustom();

  const setLoading = (_isLoading: boolean) => setState({ _isLoading });
  const isLoading = state._isLoading === undefined ? true : state._isLoading;

  return { isLoading, setLoading };
};